import { X, Smartphone, User, Phone, Wallet } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

type Props = {
  isOpen: boolean
  data: any | null
  onClose: () => void
}

export default function SearchResultModal({ isOpen, data, onClose }: Props) {
  if (!data) return null

  const isSold = data.status === "SOLD"

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-3xl shadow-xl w-full max-w-md p-6 space-y-6"
            initial={{ scale: 0.9, y: 40 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 40 }}
          >
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-semibold flex items-center gap-2">
                <Smartphone size={20} />
                Détails du téléphone
              </h2>
              <button onClick={onClose}>
                <X />
              </button>
            </div>

            {/* Model */}
            <div className="bg-gray-50 rounded-2xl p-4 space-y-1">
              <p className="text-sm text-gray-500">Modèle</p>
              <p className="text-lg font-semibold text-gray-800">
                {data.modelId?.name}
              </p>
              <p className="text-xs text-gray-500">
                IMEI : {data.imei}
              </p>
            </div>

            {/* Status */}
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-500">Statut</span>
              {isSold ? (
                <span className="px-3 py-1 rounded-full text-xs bg-red-100 text-red-600">
                  Vendu
                </span>
              ) : (
                <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-600">
                  En stock
                </span>
              )}
            </div>

            {/* Client info */}
            {isSold && (
              <div className="border rounded-2xl p-4 space-y-2">
                <div className="flex items-center gap-2 text-sm">
                  <User size={14} />
                  <span className="font-medium">{data.clientName}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <Phone size={14} />
                  {data.clientPhone}
                </div>
              </div>
            )}

            {/* Financials */}
            {isSold && (
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-green-50 rounded-xl p-3 text-center">
                  <p className="text-xs text-gray-500">Payé</p>
                  <p className="font-semibold text-green-700">
                    {data.paid?.toLocaleString()} FCFA
                  </p>
                </div>

                <div className="bg-red-50 rounded-xl p-3 text-center">
                  <p className="text-xs text-gray-500">Reste</p>
                  <p className="font-semibold text-red-600">
                    {data.remaining?.toLocaleString()} FCFA
                  </p>
                </div>
              </div>
            )}

            {/* Footer */}
            <div className="flex justify-end pt-2">
              <button
                onClick={onClose}
                className="px-4 py-2 rounded-xl border hover:bg-gray-50"
              >
                Fermer
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
